import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import { useFormik } from "formik";

import moment from "moment";
import { FaFileExcel } from "react-icons/fa";
import { IoReload } from "react-icons/io5";
import { MdAdd } from "react-icons/md";
import { GroupInput } from "../../../components/Form/GroupInput";
import { Input } from "../../../components/Form/Input";
import { Select } from "../../../components/Form/Select";
import { PanelAndDetailAndCreateHeader } from "../../../components/panel/PanelAndDetailAndCreateHeader";
import { PanelFilter } from "../../../components/panel/PanelFilter";
import { PanelLayout } from "../../../components/panel/PanelLayout";
import { Pagination } from "../../../components/panel/table/Pagination";
import {
  FieldProps,
  TableContent,
} from "../../../components/panel/table/TableContent";
import { TableHeader } from "../../../components/panel/table/TableHeader";
import {
  getRegisterSellers,
  RegisterSeller,
  useRegisterSellers,
} from "../../../hook/queries/useRegisterSeller";
import { SellerFilters } from "../../../hook/queries/useSeller";
import { setQueryParams, useQueryParams } from "../../../hook/useQueryParams";
import { generateXlsx } from "../../../utils/generateXlsx";
import { objectToForEach } from "../../../utils/objectToForEach";
import { setFormikValues } from "../../../utils/setFormikValues";

export const columnsRegisterSeller: FieldProps<RegisterSeller>[] = [
  {
    name: "fullName",
    field: "NOME COMPLETO",
    viewList: true,
  },
  {
    name: "status",
    field: "SITUAÇÃO",
    viewList: true,
    render: (invoice) => {
      return (
        <nav
          style={{
            color: "#000",
            fontWeight: "bold",
            backgroundColor: invoice.status.color,
            borderRadius: 6,
            fontSize: 12,
            padding: "4px 0",
          }}
        >
          {invoice.status.name}
        </nav>
      );
    },
  },
  {
    name: "aliasName",
    field: "ABREVIAÇÃO",
    viewList: true,
  },
  {
    name: "email",
    field: "EMAIL",
    viewList: true,
  },
  {
    name: "phone",
    field: "TELEFONE",
    viewList: true,
  },
  {
    name: "manager",
    field: "GERENTES",
    viewList: true,
    render: (row) => {
      return row.manager?.abbreviation;
    },
  },
  {
    name: "brand",
    field: "MARCAS",
    viewList: true,
    render: (row) => {
      return row.brand?.name;
    },
  },
  {
    name: "create_at",
    field: "CRIANDO EM ",
    viewList: true,
    render: (row) => {
      return moment(row.created_at).format("DD/MM/YYYY");
    },
  },
];

type Props = {
  admin?: boolean;
};

const PanelRegisterSellers: React.FC<Props> = ({ admin }) => {
  const history = useHistory();
  const query = useQueryParams();

  const [page, setPage] = useState<number>(() => {
    const pageQuery = query.get("page");

    if (!isNaN(Number(pageQuery)) && Number(pageQuery) > 0)
      return Number(pageQuery);

    return 1;
  });

  const [viewFilter, setViewFilter] = useState(false);

  const formikFilter = useFormik({
    initialValues: {
      aliasName: "",
      fullName: "",
      email: "",
      status: "",
    },
    onSubmit: (data) => {
      handleFilter(data as any);
    },
  });

  const [filters, setFilters] = useState(() => {
    let filtersValueQueryParams = {};
    query.forEach((value, key) => {
      const findOne = columnsRegisterSeller.find((f) => f.name === key);

      const valueNormalized = ["groups", "brands"].includes(key)
        ? value.split(",")
        : value;

      if (findOne) {
        filtersValueQueryParams = {
          ...filtersValueQueryParams,
          [key]: valueNormalized,
        };
      }
    });

    return filtersValueQueryParams;
  });

  const { data, isLoading, isFetching, refetch } = useRegisterSellers(
    page,
    filters,
    15
  );

  function handleNew() {
    if (admin) {
      history.push("/admin/criar/cadastro-representante");
    } else {
      history.push("/representante/criar/cadastro-representante");
    }
  }
  function handleFilter(filter: SellerFilters) {
    setFilters({
      ...filter,
      brands: !!filter.brands?.length ? filter.brands : undefined,
      groups: !!filter.groups?.length
        ? filter?.groups?.map((f) => Number(f))
        : undefined,
    });
    setPage(1);
    setViewFilter(false);
  }

  function normalizedFilters(value: any, label: string) {
    let normalized = value;

    switch (label) {
      case "active":
        if (Number(value) === 1) {
          normalized = "ATIVO";
        } else {
          normalized = "INATIVO";
        }

        break;
    }

    return normalized;
  }

  async function handleExport() {
    const getData = await getRegisterSellers(1, filters, 99999);
    const data = getData.registerSellers.map((item) => ({
      "NOME COMPLETO": item.fullName,
      SITUAÇÃO: item.status.name,
      ABREVIAÇÃO: item.aliasName,
      EMAIL: item.email,
      TELEFONE: item.phone,
      GERENTES: item.manager?.abbreviation,
      MARCAS: item.brand?.name,
      "CRIANDO EM": moment(item.created_at).format("DD/MM/YYYY"),
    }));
    generateXlsx({ data, filename: "cadastro_representante.xlsx" });
  }
  useEffect(() => {
    if (page > 0) {
      setQueryParams({
        data: {
          field: "page",
          value: String(page),
        },
        type: "set",
        history,
      });
    }
  }, [page, history]);

  useEffect(() => {
    let filtersValueQueryParams = {};
    query.forEach((value, key) => {
      const findOne = columnsRegisterSeller.find((f) => f.name === key);

      const valueNormalized = ["groups", "brands"].includes(key)
        ? value.split(",")
        : value;

      if (findOne) {
        filtersValueQueryParams = {
          ...filtersValueQueryParams,
          [key]: valueNormalized,
        };
      }
    });

    setFormikValues(filtersValueQueryParams, formikFilter);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    objectToForEach(filters, (key, value) => {
      if (value) {
        setQueryParams({
          data: {
            field: String(key),
            value: String(value),
          },
          type: "set",
          history,
        });
      } else {
        setQueryParams({
          data: {
            field: String(key),
          },
          type: "delete",
          history,
        });
      }
    });

    setFormikValues(filters, formikFilter);
    // eslint-disable-next-line
  }, [filters]);

  return (
    <PanelLayout>
      <PanelAndDetailAndCreateHeader title="Lista de cadastro de representante" />

      <PanelFilter
        filters={filters}
        setFilters={setFilters}
        columns={columnsRegisterSeller}
        onSubmit={formikFilter.handleSubmit}
        onResetForm={formikFilter.resetForm}
        setViewFilter={setViewFilter}
        viewFilter={viewFilter}
        normalizedFilters={normalizedFilters}
      >
        <GroupInput>
          <Input
            label="Abreviação"
            {...formikFilter.getFieldProps("aliasName")}
          />
          <Input
            label="Nome completo"
            {...formikFilter.getFieldProps("fullName")}
          />
          <Input label="Email" {...formikFilter.getFieldProps("email")} />
        </GroupInput>

        <GroupInput>
          <Select
            label="Situação"
            data={
              data?.filters.status.map((item) => ({
                name: item.name,
                value: String(item.id),
              })) ?? []
            }
            {...formikFilter.getFieldProps("status")}
          />
          <Select
            label="Marca"
            data={
              data?.filters.brand.map((item) => ({
                name: item.name,
                value: String(item.id),
              })) ?? []
            }
            {...formikFilter.getFieldProps("brand")}
          />
        </GroupInput>
      </PanelFilter>

      <TableHeader title="REPRESENTANTES" isFetching={isFetching && !isLoading}>
        <button style={{ background: "#2d792f" }} onClick={handleExport}>
          <FaFileExcel size={19} />
          <span>EXPORTAR</span>
        </button>

        <button onClick={() => refetch()}>
          <IoReload size={19} />
          <span>RECARREGAR</span>
        </button>

        <button onClick={handleNew}>
          <MdAdd size={19} />
          <span>NOVO</span>
        </button>
      </TableHeader>

      <TableContent<RegisterSeller>
        data={data?.registerSellers}
        columns={columnsRegisterSeller.filter((f) => f.viewList)}
        isLoading={isLoading}
        onClickRow={(e) => {
          if (admin) {
            history.push(`/admin/cadastro-representante/${e.id}`);
          } else {
            history.push(`/representante/cadastro-representante/${e.id}`);
          }
        }}
      />

      <Pagination
        totalCountOfRegisters={data?.totalCount ?? 0}
        currentPage={page}
        onPageChange={setPage}
        registersPerPage={15}
      />
    </PanelLayout>
  );
};

export default PanelRegisterSellers;
